module.exports = __webpack_public_path__ + "static/media/back.9e07fa36.svg";